import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a2a3caf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-item-box" }
const _hoisted_2 = { class: "list-item-header" }
const _hoisted_3 = { class: "list-item-left-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-tag-box" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-tag-box" }, null, -1))
const _hoisted_6 = { class: "operation-btn" }
const _hoisted_7 = { class: "list-item-body-table" }
const _hoisted_8 = { class: "table-row01" }
const _hoisted_9 = ["rowspan"]
const _hoisted_10 = { class: "align-left-box" }
const _hoisted_11 = ["rowspan"]
const _hoisted_12 = {
  class: "align-left-box",
  style: {"padding":"0 5px"}
}
const _hoisted_13 = ["rowspan"]
const _hoisted_14 = { class: "ext-message-box" }
const _hoisted_15 = ["rowspan"]
const _hoisted_16 = {
  class: "align-left-box",
  style: {"padding":"0 5px"}
}
const _hoisted_17 = ["rowspan"]
const _hoisted_18 = {
  class: "align-left-box",
  style: {"padding":"0 5px"}
}
const _hoisted_19 = ["rowspan"]
const _hoisted_20 = { class: "align-right-box" }
const _hoisted_21 = {
  key: 0,
  class: "buy-remake-box remake-box"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "买家留言：", -1))
const _hoisted_23 = {
  key: 1,
  class: "remake-box"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卖家备注：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoodsItem = _resolveComponent("GoodsItem")!
  const _component_ReturnItem = _resolveComponent("ReturnItem")!
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, "订单号：" + _toDisplayString(_ctx.modelValue.orderNumber), 1),
        _hoisted_4,
        _createElementVNode("div", null, "下单时间：" + _toDisplayString(_ctx.$format(_ctx.modelValue.createTime)), 1),
        _hoisted_5,
        _createElementVNode("div", null, "付款方式：" + _toDisplayString(_ctx.payType), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "operat-tag-box",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remake && _ctx.remake(...args)))
        }, "备注")
      ])
    ]),
    _createElementVNode("table", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.orderGoods, (item, i) => {
        return (_openBlock(), _createElementBlock("tr", { key: i }, [
          _createElementVNode("td", _hoisted_8, [
            _createVNode(_component_GoodsItem, { modelValue: item }, null, 8, ["modelValue"])
          ]),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: "table-row02",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.returnList, (item, i) => {
                    return (_openBlock(), _createBlock(_component_ReturnItem, {
                      modelValue: item,
                      key: i
                    }, null, 8, ["modelValue"]))
                  }), 128)),
                  (_ctx.modelValue.status == 1 || _ctx.modelValue.status == 2)
                    ? (_openBlock(), _createBlock(_component_ui_button, {
                        key: 0,
                        style: {"margin-top":"10px"},
                        onClick: _ctx.returnGoods
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("退款")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_9))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 1,
                class: "table-row03",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.modelValue.payAmount), 1)
              ], 8, _hoisted_11))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 2,
                class: "table-row04",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, "买家：" + _toDisplayString(_ctx.modelValue.userInfo.name), 1),
                  _createElementVNode("div", null, "收货人：" + _toDisplayString(_ctx.modelValue.username) + " " + _toDisplayString(_ctx.modelValue.mobile), 1),
                  (_ctx.modelValue.extMessage)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.modelValue.extMessage, (item) => {
                        return (_openBlock(), _createElementBlock("div", null, _toDisplayString(item.name) + " : " + _toDisplayString(item.value), 1))
                      }), 256))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_13))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 3,
                class: "table-row05",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.expressType), 1)
              ], 8, _hoisted_15))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 4,
                class: "table-row06",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.orderStatus), 1)
              ], 8, _hoisted_17))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 5,
                class: "table-row07",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.modelValue.status == 0)
                    ? (_openBlock(), _createBlock(_component_ui_button, {
                        key: 0,
                        onClick: _ctx.modifyPrice
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("改价")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.modelValue.status == 1)
                    ? (_openBlock(), _createBlock(_component_ui_button, {
                        key: 1,
                        onClick: _ctx.sendGoods
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("发货")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_19))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_ctx.modelValue.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createTextVNode(" " + _toDisplayString(_ctx.modelValue.message), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.modelValue.remake)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createTextVNode(" " + _toDisplayString(_ctx.modelValue.remake), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}